import type { CommonResponses, GoalsDashboard } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import type { FilterValues as GroupFilterValues } from 'screens/Groups/GroupReports/GoalsOverview/types'
import { getQueryParams } from 'utils/getQueryParams'
import type { FilterValues as DashboardFilterValues } from '../types'

type DashboardParams = DashboardFilterValues &
  GroupFilterValues & {
    group?: boolean | null
  }

export const useGoalsDashboard = (filterValues: DashboardParams) => {
  const GET_GOALS_STATS = `/api/goals/dashboard`
  const queryParams = getQueryParams({
    fromDate: dayjs(filterValues.rangePicker?.[0])
      .local()
      .startOf('month')
      .toISOString(),
    toDate: dayjs(filterValues.rangePicker?.[1])
      .local()
      .endOf('month')
      .toISOString(),
    resident: filterValues.resident,
    site: filterValues.site,
    group: filterValues.group
  })

  const { data, isLoading } = useQuery<
    CommonResponses.GenericResponse<GoalsDashboard>
  >(
    [
      'goals-dashboard',
      filterValues.rangePicker,
      filterValues.resident,
      filterValues.site,
      filterValues.group
    ],
    () =>
      getJSON({
        url: `${GET_GOALS_STATS}?${queryParams}`
      }),
    { enabled: true }
  )

  return { data: data?.data || null, isLoading }
}
